import { Pipe, PipeTransform } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Pipe({
  standalone: false,
  name: 'tabfilter'
})
export class TabFilterPipe implements PipeTransform {
  transform(tabList: MenuItem[], searchTerm: string, originalTabList: MenuItem[]): any[] {
    if (!tabList || !searchTerm) {
      return originalTabList;
    } else {
      tabList= JSON.parse(JSON.stringify(originalTabList));
    }

    searchTerm = searchTerm.toLowerCase();

    return this.recursiveSearchInMenu(tabList, searchTerm);
  }

  private recursiveSearchInMenu(tabList: MenuItem[], searchTerm: string): MenuItem[] {
    const matchingTabs: MenuItem[] = [];

    tabList.forEach((tab) => {
      if (tab.label.toLowerCase().includes(searchTerm)) {
        matchingTabs.push(tab);
      } else {
        const matchingChildren = this.recursiveSearchInMenu(tab.items, searchTerm);

        if (matchingChildren.length > 0) {
          tab.items = matchingChildren;
          matchingTabs.push(tab);
        }
      }
    });

    return matchingTabs;
  }

}

